import React, { useEffect, useState, useRef } from 'react';
import './SlotCounter.css';

function SingleDigit({ digit, isNegative }) {
  const [displayDigit, setDisplayDigit] = useState(digit);
  const [animClass, setAnimClass] = useState('');
  const prevDigit = useRef(digit);

  useEffect(() => {
    if (digit !== prevDigit.current) {
      const direction = digit > prevDigit.current ? 'roll-up' : 'roll-down';
      setAnimClass(`slot-exit-${direction}`);

      setTimeout(() => {
        setDisplayDigit(digit);
        setAnimClass(`slot-enter-${direction}`);

        setTimeout(() => {
          setAnimClass('');
        }, 300);
      }, 150);

      prevDigit.current = digit;
    }
  }, [digit]);

  return (
    <span className={`slot-digit ${animClass}`}>
      {displayDigit}
    </span>
  );
}

export default function SlotCounter({ value }) {
  const isNeg = value < 0;
  const absStr = String(Math.abs(value)).padStart(1, '0');
  const digits = absStr.split('');

  return (
    <div className="slot-counter">
      <span className="slot-label">PUNKTE</span>
      <div className="slot-display">
        {isNeg && <span className="slot-minus">−</span>}
        {digits.map((d, i) => (
          <SingleDigit key={`pos-${digits.length - i}`} digit={d} isNegative={isNeg} />
        ))}
      </div>
    </div>
  );
}
